module.exports = __webpack_public_path__ + "img/vip.ec539475.png";